import { ChangeDetectionStrategy, Component, computed, Inject, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  INotificationConfig,
  NotificationService,
} from '@x/ecommerce-shop/app/core/notification/notification.service';
import { DeliveryContextNotificationComponent } from '@x/ecommerce-shop/app/core/order/components/delivery-context/delivery-context-notification/delivery-context-notification.component';
import { NeedHelpModule } from '@x/ecommerce-shop/app/core/shop-ui/components/need-help/need-help.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { IShopConfig, SHOP_CONFIG } from '@x/ecommerce-shop/config/shop.config';

@Component({
  selector: 'x-delivery-context-trigger',
  standalone: true,
  imports: [FaIconComponent, MatButton, NeedHelpModule, UtilsModule],
  templateUrl: './delivery-context-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-delivery-context-trigger' },
})
export class DeliveryContextTriggerComponent {
  private defaultLabel = 'Delivery From';

  hasShippingSlot = input<boolean>(false);
  label = input<string>();
  shippingLabel = computed(() => {
    return this.hasShippingSlot() && this.label() ? this.label() : this.defaultLabel;
  });

  constructor(
    @Inject(SHOP_CONFIG) private shopConfig: IShopConfig,
    private notificationService: NotificationService,
  ) {}

  config: INotificationConfig = {
    component: DeliveryContextNotificationComponent,
  };

  showContext() {
    if (!this.shopConfig.features.nextDayDelivery) return;

    this.notificationService.notification$(this.config).subscribe();
  }
}
